module.exports = __webpack_public_path__ + "img/2ce39d4.svg";